import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async updateNewPrice(id, val) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${id}:adjust-value/`,
      method: HttpMethod.POST
    };

    const payload = {
      adjustedAmount: val
    };
    try {
      const res = await processRequest(ep, { data: payload });

      const item = processSuccessResponse(res);

      return { item };
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
